import {
  InputLeftElement,
  InputRightElement,
  InputGroup,
  Box,
  Input as ChakraInput,
} from "@chakra-ui/react";

const Input = ({
  w,
  width,
  label,
  _container,
  startAdornment,
  endAdornment,
  _endAdornment,
  ...props
}) => {
  return (
    <>
      <Box className="bitmama--input" w={w} width={width} {..._container}>
        {label && (
          <Box
            as="label"
            display="inline-block"
            fontSize=".85em"
            fontWeight="400"
            mb="8px"
            color="#4E4B66"
          >
            {label}
          </Box>
        )}
        <InputGroup>
          {startAdornment && (
            <InputLeftElement
              right="20px"
              h="100%"
              color="#A0A3BD"
              // p="28px 50px"
              w="70px"
              children={startAdornment}
              // pos="relative"
              zIndex={1}
            />
          )}
          {endAdornment && (
            <InputRightElement
              right="20px"
              h="100%"
              color="#A0A3BD"
              // p="28px 50px"
              w="fit-content"
              children={endAdornment}
              // pos="relative"
              zIndex={1}
              {...(_endAdornment ?? {})}
            />
          )}
          <ChakraInput
            w={w}
            width={width}
            borderRadius="16px"
            errorBorderColor="red.300"
            minH="56px"
            bg="#EFF0F7"
            border="1px solid transparent"
            variant="filled"
            _focus={{
              borderColor: "#06C344",
              boxShadow: "0 0 0 3px #06C3448f",
            }}
            pl={startAdornment ? "60px" : "1rem"}
            {...props}
          />
        </InputGroup>
      </Box>
    </>
  );
};

export default Input;
